import store from "../store"

const defaultState = {
    byIds: {},
    allIds: [],
    loading: false,
    error: undefined
} 

const authReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_FLOOR_CATEGORIES_REQUEST": 
            return { ...state, loading: true }
        case "GET_FLOOR_CATEGORIES_SUCCESS":
            let { floor_categories } = action.payload.data
            for (let floor_category of floor_categories) {
                state.byIds[floor_category.id] = floor_category
                if (state.allIds.indexOf(floor_category.id) === -1) state.allIds.push(floor_category.id);
            }
            return { ...state, error: undefined, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        case "GET_FLOOR_CATEGORIES_FAILED":
            return { ...state, error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        default:
            return state;
    }
}

export default authReducer;